//PrintAddressChange.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as MainMap from "../MainMap";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as PrintAddressChangeMap from "./PrintAddressChangeMap";
import * as PrintAddressChangeUI from "./PrintAddressChangeUI";
import React from "react";
import ReactDOM from "react-dom/client";


export let pageWidth: string;
export let pageHeight: string;

//Setters.
export function setPageWidth(width: string) {
   pageWidth = width;
}
export function setPageHeight(height: string) {
   pageHeight = height;
}

//Build the layout. //Print map step 3 of 4.
export function render() {
   Util.logMsg("Building main print layout component");

   if (!Settings.printDivRoot) {
      Settings.setPrintDivRoot(ReactDOM.createRoot(document.getElementById("print_div")));
   }
   Settings.printDivRoot.render(<RenderAddressChange />);
}

interface iProps {
}

//Render function.
export function RenderAddressChange(props: iProps) {

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   return (
      <div>
         <PrintAddressChangeMap.Render />
      </div>
   ); //end return.

} //end function.
